import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Grid } from '@mui/joy';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import './TechnologyFormStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomTextArea from '../../../../Components/custom_components/CustomTextArea/CustomTextArea';
import { TbFileDescription } from 'react-icons/tb';
import { statusOptions } from '../../../../utils/constants';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import CustomTooltip from '../../../../Components/custom_components/CustomTooltip/CustomTooltip';

function TechnologyForm({ handleTechnologySave, isButtonDisabled, formIntialValues, id, isDisabled }) {

    const formik = useFormik({
        initialValues: formIntialValues, // Set initial values directly from props
        validationSchema: Yup.object({
            TechnologiesTypeName: Yup.string().required('Technology name is required'),
            TechnologiesTypeStatus: Yup.string().required('Status is required'),
            // TechnologiesShortcode: Yup.string().required('Shortcode is required'),
            TechnologiesShortcode: Yup.string().required('Shortcode is required')
                .min(3, 'Shortcode Code must be at least 3 characters')
                .max(10, 'Shortcode must not exceed 10 characters.'),
        }),
        enableReinitialize: true, // Enable re-initialization of form values when props change
        onSubmit: (values) => {
            handleTechnologySave(values, id);
        },
    });

    // Reset handler
    const handleReset = () => {
        formik.setFieldValue('TechnologiesTypeStatus', 1);
        formik.setFieldValue('TechnologiesTypeName', '');
        formik.setFieldValue('TechnologiesShortcode', '');
        formik.setFieldValue('TechnologiesDescription', '');

        // Reset warning messages
        formik.setTouched({
            TechnologiesTypeName: false,
            TechnologiesTypeStatus: false,
            TechnologiesShortcode: false,
        });
    };


    return (
        <div className='technology-form-container'>
            {/* FORM START */}
            <Grid container spacing={2}>
                {/* LEFT SIDE */}
                <Grid item xs={12} md={6}>
                    <div className='technology-form-mid-container'>
                        <div className='technology-label-container'>
                            <span className='technology-label'>
                                Technology Name <span className='technology-required-remark'>*</span>
                            </span>
                        </div>
                        <CustomTooltip title={isDisabled ? formik.values.TechnologiesTypeName : ''}>
                            <div className='technology-custom-textfield-container'>
                                <CustomTextFieldWithIcon
                                    id='TechnologiesTypeName'
                                    name='TechnologiesTypeName'
                                    placeholder='Enter technology name'
                                    value={formik?.values?.TechnologiesTypeName}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.TechnologiesTypeName && Boolean(formik.errors.TechnologiesTypeName)}
                                    helperText={formik.touched.TechnologiesTypeName && formik.errors.TechnologiesTypeName}
                                    isDisabled={isDisabled}
                                />
                            </div>
                        </CustomTooltip>

                    </div>
                    {/* Description */}
                    <div className="label-container">
                        <span className="label">Description<span className='label_required_remark'></span></span>
                    </div>
                    <div className="custom-textfield-container">
                        <CustomTextArea
                            id="TechnologiesDescription"
                            name="TechnologiesDescription"
                            placeholder="Enter Description"
                            value={formik.values.TechnologiesDescription}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            rows={5}
                            error={formik.touched.TechnologiesDescription && Boolean(formik.errors.TechnologiesDescription)}
                            helperText={formik.touched.TechnologiesDescription && formik.errors.TechnologiesDescription}
                            StartIcon={TbFileDescription}
                            isDisabled={isDisabled}

                        />
                    </div>

                </Grid>
                {/* RIGHT SIDE */}
                <Grid item xs={12} md={6}>

                    {/* SHORTCODE INPUT */}
                    <div className='technology-form-mid-container'>
                        <div className='technology-label-container'>
                            <span className='technology-label'>
                                Technology  Shortcode <span className='technology-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='technology-custom-textfield-container'>
                            <CustomTextFieldWithIcon
                                id='TechnologiesShortcode'
                                name='TechnologiesShortcode'
                                placeholder='Enter technology shortcode'
                                value={formik?.values?.TechnologiesShortcode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.TechnologiesShortcode && Boolean(formik.errors.TechnologiesShortcode)}
                                helperText={formik.touched.TechnologiesShortcode && formik.errors.TechnologiesShortcode}
                                isDisabled={isDisabled}
                                maxLength={10}
                            />
                        </div>
                    </div>

                    {id && <div className='technology-form-mid-container'>
                        <div className='technology-label-container'>
                            <span className='technology-label'>
                                Status <span className='technology-required-remark'>*</span>
                            </span>
                        </div>
                        <div className='technology-custom-textfield-container'>

                            <CustomSelectDropdown
                                name="TechnologiesTypeStatus"
                                placeholder="Select Status"
                                options={statusOptions}
                                value={statusOptions?.find(option => option?.value === formik?.values?.TechnologiesTypeStatus) || ""}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("TechnologiesTypeStatus", selectedOption ? selectedOption.value : "");
                                }}
                                onBlur={formik.handleBlur}
                                error={formik.touched.TechnologiesTypeStatus && Boolean(formik.errors.TechnologiesTypeStatus)}
                                helperText={formik.touched.TechnologiesTypeStatus && formik.errors.TechnologiesTypeStatus}
                                isDisabled={isDisabled}
                                isMulti={false} // Set to false for single-select
                                width="100%"
                                isClearable={false}
                            />

                        </div>
                    </div>}


                </Grid>
            </Grid>
            {!isDisabled && <div className='technology-form-bottom-action-buttons-container'>
                <ActionButton onClick={handleReset} label='Reset' btnType='outlined' />
                <ActionButton
                    onClick={() => formik.handleSubmit()}
                    btnDisable={isButtonDisabled}
                    label='Save'
                    btnType='primary'
                />
            </div>}

        </div>
    );
}

export default TechnologyForm;
